<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            Historial ordenes de compra
            <router-link
              :to="{
                name: 'NuevaOrdenCompra',
                params: {
                  config: {
                    page: page,
                    dates: selectedDate,
                    almacen: almacen
                  }
                }
              }"
            >
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-pencil" />Registrar orden de compra
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md="4" lg="4" xl="4">
                <label class="d-block">Periodo:</label>
                <DateSelector
                  class="z-custom-2"
                  v-model="selectedDate"
                  :date="selectedDate"
                  @input="dateSelection()"
                />
              </CCol>
              <CCol md="8" lg="8" xl="8">
                <label>Almacén:</label>
                <v-select
                  v-model="almacen"
                  :options="almacenes"
                  @input="filterLotes()"
                  :loading="isLoading"
                  class="margin-multi"
                  placeholder="Selecciona un almacén"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
            </CRow>

            <CDataTable
              hover
              bordered
              responsive
              :loading="isLoading"
              :items="this.items"
              :fields="fields"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
            >
              <template #over-table>
                <CRow>
                  <CCol sm="11" col="10">
                    <CInput v-model="filter" @input="searchTimeOut()" placeholder="Búsqueda..." />
                  </CCol>
                  <CCol class="p-0" sm="1" col="2">
                    <CDropdown
                      placement="bottom-start"
                      add-menu-classes="pt-0"
                      color="primary"
                      :show.sync="dropdownCustom"
                    >
                      <template #toggler>
                        <CButton color="secondary">
                          <CIcon name="cil-settings" />
                        </CButton>
                      </template>

                      <template #default>
                        <div class="p-3 d-flex flex-column w-100">
                          <div class="mb-1">
                            <span>
                              <strong>Ver</strong>
                            </span>
                          </div>
                          <hr class="line mt-1 mb-3" />

                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Cancelados:</label>
                            <CSwitch
                              @update:checked="toggleShowCancel()"
                              class="mx-1"
                              color="primary"
                              variant="3d"
                            />
                          </div>
                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Autor:</label>
                            <CSwitch @update:checked="toggleMostrarAutor()" class="mx-1" color="primary" variant="3d" />
                          </div>
                        </div>
                      </template>
                    </CDropdown>
                  </CCol>
                </CRow>
              </template>
              <template #folio-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Folio</span>
                  <OrderButtons :onClick="sortField" :field="'doc_ordenes_compra.folio'" :order="false" :fila="actualSort" :direcction="sorting"/>
                </div>
              </template>
              <template #fechahora-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Fecha</span>
                  <OrderButtons :onClick="sortField" :field="'doc_ordenes_compra.payload->encabezado->fechahora'" :order="false" :fila="actualSort" :direcction="sorting"/>
                </div>
              </template>
              <template #almacen_id-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Almacén</span>
                  <OrderButtons :onClick="sortField" :field="'almacen.payload->nombre'" :order="true" :fila="actualSortJoin" :direcction="sortingJoin"/>
                </div>
              </template>
              <template #proveedor_id-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Proveedor</span>
                  <OrderButtons :onClick="sortField" :field="'payload->encabezado->proveedor_id'" :order="false" :fila="actualSort" :direcction="sorting"/>
                </div>
              </template>
              <template #folio="{item}">
                <td class="py-2">{{ item.folio }}</td>
              </template>
              <template #fechahora="{item}">
                <td class="py-2">{{ getDate(item.payload.encabezado.fechahora) }}</td>
              </template>
              <template #estado="{item}">
                <td class="py-2">{{ item.estado }}</td>
              </template>
              <template #almacen_id="{item}">
                <td class="py-2">{{ item.payload.encabezado._relaciones.almacen.payload.nombre }}</td>
              </template>
              <template #proveedor_id="{item}">
                <td class="py-2">{{ item.payload.encabezado._relaciones.proveedor?item.payload.encabezado._relaciones.proveedor.payload.nombre:'' }}</td>
              </template>
              <template #importe="{item}">
                <td class="py-2">{{ formatCurrency(item.total) }}</td>
              </template>
              <template #autorizar="{item, index}">
                <td class="py-2">
                  <div class="d-flex no-gap">
                    <CButton
                    v-if="item.payload.encabezado.autorizada === undefined"
                    color="info"
                    square
                    size="sm"
                    class="btn-left"
                    @click="()=>toggleAutorizar(index, item, true)"
                    >Si</CButton>
                    <CButton
                    v-if="item.payload.encabezado.autorizada === undefined"
                    color="danger"
                    square
                    size="sm"
                    class="btn-right"
                    @click="()=>toggleAutorizar(index, item, false)"
                    >No</CButton>
                  </div>
                  <span v-if="item.payload.encabezado.autorizada === false" class="text-danger">No autorizada</span>
                  <span v-if="item.payload.encabezado.autorizada === true" class="text-success">Autorizada</span>
                </td>
              </template>
              <template #autor-header>
                <div class="d-flex flex-row">
                  <span v-show="mostrarColumnaAutor">Autor</span>
                </div>
              </template>
              <template #autor="{item}">
                <td class="py-2">
                  <span v-show="mostrarColumnaAutor">{{ item.author.correo }}</span>
                </td>
              </template>
              <template #ver="{item}">
                <td class="py-2">
                  <router-link
                    :to="{
                      name: 'VerOrdenCompra',
                      params: {
                        id: item.folio,
                        config: {
                          page: page,
                          dates: selectedDate,
                          almacen: almacen
                        }
                      }
                    }"
                  >
                    <CButton color="success" square size="sm">Ver</CButton>
                  </router-link>
                </td>
              </template>
              <template #reporte="{item, index}">
                <td class="py-2">
                  <CButton
                    v-if="true||!!item.payload.encabezado.autorizada"
                    color="info"
                    square
                    size="sm"
                    @click="getReporte(index, item)"
                  >
                  <i v-if="loader[index]" class="fa fa-spinner fa-pulse"></i>
                  <template v-else>PDF</template>
                  </CButton>
                </td>
              </template>
              <template #cancel="{item, index}">
                <td class="py-2">
                  <CButton
                    color="danger"
                    square
                    size="sm"
                    @click="toggleCancel(index, item)"
                  >Cancelar</CButton>
                </td>
              </template>
              <template #under-table>
                <CPagination
                  :activePage.sync="page"
                  :pages="pages"
                  align="center"
                  @update:activePage="e => actualizarInfo(e)"
                />
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Cancelar orden de compra"
      color="danger"
    >
      <h5 class="text-center">¿Deseas cancelar la orden de compra con folio {{ this.itemModal.name }}?</h5>
      <template #header>
        <h5 class="modal-title">Cancelar Orden de Compra</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton @click="cancelDocto(itemModal.index, itemModal.id)" color="success">Aceptar</CButton>
      </template>
    </CModal>

    <CModal
      :show.sync="autorizarModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Autorizar orden de compra"
      color="info"
    >
      <h5 v-if="autorizarModalStatus" class="text-center">¿Deseas autorizar la orden de compra con folio {{ this.itemModal.name }}?</h5>
      <h5 v-else class="text-center">¿Deseas desautorizar la orden de compra con folio {{ this.itemModal.name }}?</h5>
      <template #header>
        <h5 v-if="autorizarModalStatus" class="modal-title">Autorizar Orden de Compra</h5>
        <h5 v-else class="modal-title">Desautorizar Orden de Compra</h5>
        <CButtonClose @click="autorizarModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="autorizarModal = false" color="danger">Cancelar</CButton>
        <CButton @click="autorizar(itemModal.id)" color="success">Aceptar</CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      title="Reporte"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
    >{{ error }}</CModal>
  </div>
</template>

<script>

import DateSelector from "../../../customComponents/DateSelector";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import OrderButtons from "../../../customComponents/OrderButtons";
import moment from "moment";
import GridAutorMixin from "../../../mixins/GridAutor";

const today = new Date();

const fields = [
  { key: "folio", label: "Folio", _style: "width:10%" },
  { key: "fechahora", label: "Fecha", _style: "width:10%" },
  { key: "estado", label: "Estado", _style: "width:10%" },
  { key: "almacen_id", label: "Almacén", _style: "width:10%" },
  { key: "proveedor_id", label: "Proveedor", _style: "width:10%" },
  { key: "importe", label: "Importe", _style: "width:10%" },
  {
    key: "autor",
    label: "",
    _style: "width:1%",
  },
  {
    key: "autorizar",
    label: "Autorización",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "ver",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "reporte",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];

export default {
  name: 'OrdenesCompra',
  components: {
    DateSelector,
    vSelect,
    OrderButtons
  },
  mixins: [GridAutorMixin],
  data() {
    return {

      items: [],
      fields,
      warningModal: false,
      error: "",
      filter: "",
      dropdownCustom: false,
      actualSort: "doc_ordenes_compra.payload->encabezado->fechahora",
      actualSortJoin: "",

      sorting: "desc",
      sortingJoin: "",
      autorizarModal: false,
      autorizarModalStatus: true,


      isLoading: false,



      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      cancelModal: false,

      itemModal: { id: "", name: "", index: "" },

      page: 1,
      pages: 1,


      // Selector rango fecha
      selectedDate: {
        start: new Date(today.getFullYear(), today.getMonth(), 1),
        end: new Date(today.getFullYear(), today.getMonth() + 1, 0)
      },
      almacen: null,
      almacenes: [],
      loader:{},

    }
  },
  created() {
    this.actualizarInfo();
  },
  watch: {
    items(newV,){
      this.loader = newV.reduce((v,c,i)=>({...v,[i]:false}),{})
    },
    ubicacionRaiz() {
      this.cambioUbicacionRaiz = true
      this.almacen = null
      this.actualizarInfo();
    }
  },
  methods: {
    formatCurrency(value) {
      if (!value) {
        return 'N/A';
      }
      return new Intl.NumberFormat('es-MX', {style: 'currency', currency: 'MXN'}).format(value || 0);
    },
    autorizar(folio){
      this.$store.dispatch("customDocumentoActualizarHTTP", {
                schema: "ordenes_compra",
                folio,
                payload: {
                    encabezado: {
                        autorizada: this.autorizarModalStatus
                    }
                }
            }).then(() => {
                this.alertSuccess = true
            }).catch(error => {
                this.error = error.message;
                this.warningModal = true;
                this.isLoading = false;
            }).finally(() => {
                this.autorizarModal = false;
                this.isLoading = false;
                this.actualizarInfo();
            });
    },
    getReporte(index,item){
      if(this.loader[index]){
        return
      }
      this.loader[index] = true
      this.$forceUpdate();
      const reportCall = {
        reporte: "formato_ordenes_compra",
        params: { folio:item.folio, ubicaciones: [this.ubicacionRaiz]},
        pdf : true
      };

      // console.log(reportCall);
      // call.push(reportCall);


        this.$store.dispatch("reportsPDFHttp", {
          ...reportCall
        }).then(res => {

          const blob = res;

          let a = document.createElement("a");
          a.style = "display: none";
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = "Reporte ordenes de compra.pdf";
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.loader[index] = false
          this.$forceUpdate();
        });
    },
    searchTimeOut() {
      if (this.isCreated) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {

          this.actualizarInfo();
        }, 800);
      }
    },
    toggleShowCancel() {
      this.showCancel = !this.showCancel;
      this.actualizarInfo();
    },
    getDate(date) {
      return new Date(date).toLocaleDateString();
    },
    sortField(field, direction, join) {
      if (join) {
        this.actualSort = ""
        this.sorting = ""
        this.actualSortJoin = field
        this.sortingJoin = direction
      }else{
        this.actualSort = field
        this.sorting = direction
        this.actualSortJoin = ""
        this.sortingJoin = ""
      }
      this.actualizarInfo();
    },
    // Selector rango fecha
    dateSelection() {
      if (this.isCreated) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {
          // console.log("funciona");
          this.actualizarInfo();
        }, 800);
      }
    },
    filterLotes() {
      if (this.isCreated) {
        this.actualizarInfo();
      }
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.folio,
        name: item.folio,
        index: index
      };
      this.itemModal = itemIndex;
    },
    toggleAutorizar(index, item, status) {
      this.autorizarModal = true;
      this.autorizarModalStatus = status;
      const itemIndex = {
        id: item.folio,
        name: item.folio,
        index: index
      };
      this.itemModal = itemIndex;
    },
    cancelDocto(index, id) {
      this.isLoading = true;
      this.$store.dispatch('customDocumentoCancelHTTP', {
        schema: 'ordenes_compra',
        folio: id
      })
      .then(res => {
        console.log(res.data);
        this.actualizarInfo();
      })
      .catch(rej => {
        console.log(rej);
      })
      .finally(() => {
        this.isLoading = false;
        this.cancelModal = false;
      });
    },
    actualizarInfo(){
      if (this.ubicacionRaiz == '') {
        this.items = []
        return
      }

      this.isLoading = true;

      let template = {
        schema: "ordenes_compra",
        limit: 50,
        page: this.page,
        filter: {
          wherein: [{
            field: "doc_ordenes_compra.payload->encabezado->ubicacion_raiz_id",
            value: [this.ubicacionRaiz]
          }],
          where: [
            {
              field: "doc_ordenes_compra.payload->encabezado->fechahora",
              operator: ">=",
              value: moment(this.selectedDate.start).format("YYYY-MM-DD 00:00:00")
            },
            {
              field: "doc_ordenes_compra.payload->encabezado->fechahora",
              operator: "<=",
              value: moment(this.selectedDate.end).format("YYYY-MM-DD 23:59:59")
            }
          ]
        },
        ["with-storage"]: ["*"]
      };

      this.actualSort != "" ? (template = {
        ...template,
        order: [{
          field: this.actualSort,
          direction: this.sorting
        }]
      }) : null

      this.actualSortJoin != "" ? (template = {
        ...template,
        orderByJoin: [{
          field: this.actualSortJoin,
          direction: this.sortingJoin
        }]
      }) : null

      this.filter != "" ? (template = {
        ...template, filter: {
          ...template.filter,
          and: {
            orWhere: [
              {
                field: "doc_ordenes_compra.folio",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              ...this.mostrarColumnaAutor?[
              {
                field: "doc_ordenes_compra.author->correo",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              ]:[],
            ],
            orWhereJoin: [
              {
                field: "proveedor.payload->nombre",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              {
                field: "almacen.payload->nombre",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
            ]
          }
        }
      }) : null;

      !this.showCancel ? (template = {
        ...template, filter: {
          ...template.filter,
          where: [
            ...template.filter.where,
            {
              field: "doc_ordenes_compra.estado",
              operator: "!=",
              value: "cancelado"
            }
          ]
        }
      }) : null;

      if (this.almacen) {
        template = {
          ...template,
          filter: {
            ...template.filter,
            where: [
              ...template.filter.where,
              {
                field: "payload->encabezado->almacen_id",
                operator: "=",
                value: this.almacen.value
              }
            ]
          }
        };
      }

      const documento = [this.$store.dispatch("customDocumentoHTTP", template)]
      if (!this.isCreated || this.cambioUbicacionRaiz) {
        this.cambioUbicacionRaiz = false
        documento.push(this.$store.dispatch("customHTTP", {
            schema: "almacenes",
            filter: {
              wherein: [
                {
                  field: "payload->ubicacion_id",
                  value: [this.ubicacionRaiz]
                }
              ]
            }
          })
        )
      }

      Promise.all(documento)
        .then(([documentos, almacenes]) => {

          const items = documentos.data.map(item => {
            return {
              ...item,
              total: item.payload.detalles.reduce((acc, detalle) => {
                return acc + (detalle.cantidad * (detalle?.costo_unitario || 0));
              }, 0),
            };
          });

          this.items = items;

          if (!this.isCreated) {
            this.almacenes = almacenes.data.map(almacen => {
              return { value: almacen.id, label: almacen.payload.nombre };
            });
            this.almacenesAll = almacenes.data;
          }
          this.pages = documentos?.paginate?.last_page;
          this.page = documentos?.paginate?.current_page;

          this.isCreated = true;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));
    }
  },
  computed: {
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : '';
    }
  }

};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.margin-multi {
  margin-bottom: 1rem !important;
}
.cursor-p {
  cursor: pointer;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
.d-flex {
  display: flex;
}
.no-gap {
  display: flex;
}
.btn-left {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-right {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

</style>
